import script from "./TokenListTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./TokenListTable.vue?vue&type=script&lang=ts&setup=true"

import "./TokenListTable.vue?vue&type=style&index=0&id=1de4130a&lang=scss"

const __exports__ = script;

export default __exports__